




















































































































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TagsInput from '@/modules/shared/components/shared/kit/TagsInput.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { Prop } from 'vue-property-decorator'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import MessageBox from '@/modules/shared/components/shared/MessageBox.vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { ContentItemStepOneCollection } from '@/modules/content-item/models/content-item-collection.model'
import { PanelContentCampaignStore } from '@/modules/content-campaign/store/panel-content-campaign.store'
import {
  ContentItemType,
  ContentTones,
  ContentWordCount
} from '@/modules/content-item/models/content-item-resource.model'
import clone from 'just-clone'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import PanelContentItemContentTypeRadio from './PanelContentItemContentTypeRadio.vue'

@Component({
  components: { MessageBox, Modal, BaseSelect, BaseInput, TagsInput, Radio, PanelContentItemContentTypeRadio }
})
export default class PanelContentItemDraggableCard extends Vue {
  constructor(private copyStore: PanelContentCampaignStore) {
    super()
  }

  @Prop() item!: ContentItemStepOneCollection
  @Prop() words!: { [key in ContentWordCount]: string }
  @Prop() contentTones!: { [key in ContentTones]: string }
  @Prop() contentTypes!: { [key in ContentItemType]: string }
  @Prop() wordRates!: { [key in ContentItemType]: number }
  @Prop() aiWordRates!: { [key in ContentItemType]: number }
  @Prop({ default: false }) paste!: boolean
  @Prop() errors!: any
  @Prop({ default: false }) isOnly!: boolean

  expanded = false
  modal = false
  copied = false
  aiType = false

  $refs: {
    form: QForm
  }

  updated() {
    this.$refs.form.resetValidation()
  }

  get wordCount() {
    return this.item.word_count.toString()
  }

  set wordCount(value) {
    this.item.word_count = Number(value)
  }

  get wordOptions() {
    return Object.keys(this.words).map(key => ({
      label: this.words[key],
      value: key
    }))
  }

  get contentTonesOptions() {
    return Object.keys(this.contentTones).map(key => ({
      label: this.contentTones[key],
      value: key
    }))
  }

  get contentTypesOptions() {
    return Object.keys(this.contentTypes).map(key => ({
      label: `${this.contentTypes[key]} (هر کلمه ${this.item.ai_type ? this.aiWordRates[key] : this.wordRates[key]} تومان) `,
      value: key
    }))
  }

  copyObject() {
    this.copyStore.itemCopy = clone(this.item)
    this.copied = true
    setTimeout(() => {
      this.copied = false
    }, 1000)
  }

  pasteObject() {
    this.$set(this.item, 'content_type', this.copyStore.itemCopy.content_type)
    this.$set(this.item, 'delivery_order', this.item.delivery_order)
    this.$set(this.item, 'description', this.copyStore.itemCopy.description)
    this.$set(this.item, 'keywords', this.copyStore.itemCopy.keywords)
    this.$set(this.item, 'main_keyword', this.copyStore.itemCopy.main_keyword)
    this.$set(this.item, 'title', this.copyStore.itemCopy.title)
    this.$set(this.item, 'tone', this.copyStore.itemCopy.tone)
    this.$set(this.item, 'word_count', this.copyStore.itemCopy.word_count)
    this.$set(this.item, 'ai_type', this.copyStore.itemCopy.ai_type)
  }

  removeObject() {
    this.$emit('remove', this.item.id, this.item.delivery_order)
  }

  checkValidation(): Promise<any> {
    return this.$refs.form.validate()
  }

  resetValidation() {
    this.$refs.form.resetValidation()
  }
}
